import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/zncMain'
const _schoolInfo_ = file =>() => import('@/components/znc-school/school-info/'+file+'.vue');
const _teacherInfo_ = file =>() => import('@/components/znc-school/teacher-info/'+file+'.vue');
const _baseEquipment_ = file =>() => import('@/components/znc-school/base-equipment/'+file+'.vue');
const _workProspect_ = file =>() => import('@/components/znc-school/work-prospect/'+file+'.vue');
const _courseInfo_ = file => () => import('@/components/znc-school/course-info/'+file+'.vue');
const _studentStyle_ = file => () => import('@/components/znc-school/student-style/'+file+'.vue')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,
      redirect:'/schoolInfo',
      // redirect:'/bannerInfo',
      // redirect:'/openClass',
      children:[
        {
          path:'/schoolInfo',
          name:'schoolInfo',
          component:_schoolInfo_('schoolInfo'),
        },{
          path:'/infoDetails',
          name:'infoDetails',
          component:_schoolInfo_('info-details'),
        },
        {
          path:'/teacherInfo',
          name:'teacherInfo',
          component:_teacherInfo_('teacherInfo'),
        },
        {
          path:'/baseEquipment',
          name:'baseEquipment',
          component:_baseEquipment_('baseEquipment'),
        },
        {
          path:'/workProspect',
          name:'workProspect',
          component:_workProspect_('workProspect'),
        },
        {
          path:'/classInfo',
          name:'classInfo',
          component:_workProspect_('classInfo'),
        },
        {
          path:'/mechanical',
          name:'mechanical',
          component:_courseInfo_('mechanical'),
        },
        {
          path:'/electrical',
          name:'electrical',
          component:_courseInfo_('electrical'),
        },
        {
          path:'/commission',
          name:'commission',
          component:_courseInfo_('commission'),
        },{
          path:'/debug',
          name:'debug',
          component:_courseInfo_('debug'),
        },
        {
          path:'/studentStory',
          name:'studentStory',
          component:_workProspect_('studentStory'),
        },
        {
          path:'/bannerInfo',
          name:'bannerInfo',
          component:_courseInfo_('banner-info'),
        },
        {
          path:'/openClass',
          name:'openClass',
          component:_courseInfo_('open-class'),
        },
        {
          path:'/addStudent',
          name:'addStudent',
          component:_courseInfo_('add-student'),
        },
        {
          path:'/equipmentPreservation',
          name:'equipmentPreservation',
          component:_courseInfo_('equipment-preservation'),
        },
        {
          path:'/technical',
          name:'technical',
          component:_courseInfo_('technical'),
        },
        {
          path:'/dataCollection',
          name:'dataCollection',
          component:_courseInfo_('data-collection'),
        },
        {
          path:'/studentFeedback',
          name:'studentFeedback',
          component:_studentStyle_('student-feedback')
        },
        {
          path:'/wishWall',
          name:'wishWall',
          component:_studentStyle_('wish-wall')
        },
        {
          path:'/graduationWall',
          name:"graduationWall",
          component:_studentStyle_('graduation-wall')
        }
      ]
    },
    {
      path:'/equipmentInfo',
      name:'equipmentInfo',
      component:_baseEquipment_('equipmentInfo'),
    },
    {
      path:'/studentList',
      name:'studentList',
      component:_workProspect_('studentList'),
    },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js